import { ref } from '@vue/composition-api';

export const registerNewUserMenu = ref(false);
export const resetUserPasswordMenu = ref(false);
export const updateUserMenu = ref(false);
export const userMetricsMenu = ref(false);
